export default __webpack_public_path__ + "static/media/warning-icon.e8cbd276.svg";